import { render, staticRenderFns } from "./AccreditedCpds.vue?vue&type=template&id=38641a47"
import script from "./AccreditedCpds.vue?vue&type=script&lang=js"
export * from "./AccreditedCpds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports